import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CheckboxComponent, EditorComponentBase } from 'ngx-lib';

@Component({
    selector: 'app-checkbox-editor',
    templateUrl: './checkbox-editor.component.html',
    styleUrls: ['./checkbox-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CheckboxComponent]
})
export class CheckboxEditorComponent extends EditorComponentBase<boolean> {
    constructor() {
        super();
    }

    dataChanged(value: boolean): void {
        this.bindingProperty = value;
        this.valueChange.emit();
    }
}
